/**
 * 获取图片完整URL
 * 如果图片地址自带http或https，则直接返回；否则拼接baseUrl
 * @param {string} url 图片路径
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(url) {
  if (!url) return '';
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return process.env.VUE_APP_BASE_API + url;
}

//过滤富文本文字标签
const stripHtmlTags = function (str) {
    // 匹配所有 HTML 标签
    const regex = /<[^>]+>/g;
    // 将所有匹配到的 HTML 标签替换为空字符串
    return str.replace(regex, '').replace(/&nbsp;/g, '');
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].dictValue == "" + value) {
            actions.push(datas[key].dictLabel);
            return true;
        }
    });
    return actions.join("");
}
/** 日期格式化
 * @params time    时间
 * @params pattern 时间格式
 */
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
      return null;
    }
    const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
      date = time;
    } else {
      if (typeof time === "string" && /^[0-9]+$/.test(time)) {
        time = parseInt(time);
      } else if (typeof time === "string") {
        time = time
          .replace(new RegExp(/-/gm), "/")
          .replace("T", " ")
          .replace(new RegExp(/\.[\d]{3}/gm), "");
      }
      if (typeof time === "number" && time.toString().length === 10) {
        time = time * 1000;
      }
      date = new Date(time);
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key];
      // Note: getDay() returns 0 on Sunday
      if (key === "a") {
        return ["日", "一", "二", "三", "四", "五", "六"][value];
      }
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    });
    return time_str;
  }

export default {
    stripHtmlTags,
    selectDictLabel,
    parseTime
}